//ts-nocheck
import AddToCartButton from "~/components/product/AddToCartButton"
import { useSelectedProducts } from "~/sdk/atoms"
import { ImageWidget } from "~/types/widgets"
import { toProductItem } from "~/sdk/ga4/transform/toProductItem"
import type { ToAddToCart } from "~/sdk/ga4/events/add_to_cart"
import { useOffer } from "~/sdk/useOffer"
import { useMemo } from "react"

const getOffer = useOffer

export interface Props {
    text: string
    icon?: ImageWidget
    iconWidth?: number
    iconHeight?: number
    analytics?: ToAddToCart
}

export default function BuyButton(props: Props) {
    // useSelectedProducts subscribes via useStore so the BuyButton re-renders
    // when the user picks variants. The previous useComputed shim only read
    // selectedProducts.value once on mount and never updated, so the button
    // always saw an empty selection → "Selecione um produto primeiro".
    const selected = useSelectedProducts()
    const products = useMemo(() => [...selected.values()], [selected])

    const analytics = useMemo(() => ({
        items: products.map((product, index) =>
            toProductItem(product, { index, quantity: product.quantity ?? 1 })
        ),
        view: { id: 'product_page', name: 'Página de produto' },
    }), [products])

    const mappedProducts = useMemo(() =>
        products.map(({
            productID,
            quantity = 1,
            offers,
        }, index) => {
            const { seller = '1' } = getOffer(offers)

            return ({
                id: productID,
                seller,
                quantity,
                index,
            })
        }), [products])

    return (
        <AddToCartButton
            {...props}
            className='min-h-0 p-0 font-bold text-white border-2 text-base border-none rounded btn bg-red-wine hover:bg-wine border-red-wine hover:border-wine w-full md:max-w-[230px] mt-3'
            products={mappedProducts}
            variant='pdp'
            analytics={analytics}
        />
    )
}
